import React, { useEffect, useState } from 'react'
import { Element } from 'react-scroll';
import ProductsSectionTitle from '../ProductsSectionTitle';
import Select from 'react-select';
import { useLocation } from "react-router-dom";

const agents = [
  {value: "On-Site Object Quantification", label: "On-Site Object Quantification"},
  {value: "Predictive Maintenance", label: "Predictive Maintenance"},
  {value: "Emission & Environmental Monitoring", label: "Emission & Environmental Monitoring"},
  {value: "Real-Time Compliance Monitoring", label: "Real-Time Compliance Monitoring"},
  {value: "Process Optimization at the Edge", label: "Process Optimization at the Edge"},
  {value: "Autonomous Asset Inspection", label: "Autonomous Asset Inspection"}
];

const AURAAgents = () => {
  const [selectedAgent, setSelectedAgent] = useState(agents[0]);
  const [showAgentSelection, setShowAgentSelection] = useState(true);
  const [showChat, setShowChat] = useState(false);
  const [chatInput, setChatInput] = useState("");

  const location = useLocation();  

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const index = parseInt(queryParams.get("agent")) || 1;
    if (!isNaN(index) && index >= 0 && index < agents.length) {
      setSelectedAgent(agents[index]);
    } else {
      setSelectedAgent(agents[0]); // fallback to first agent
    }
  }, [location.search])

  const handleSelectedAgent = (e) => {
    setSelectedAgent(e);
  }

  const handleFormSubmit = (e) => {
    e.preventDefault();
    setShowAgentSelection(false);
    setShowChat(true);
  }

  const handleChatSubmit = (e) => {
    e.preventDefault();

    // Inset chat code here
  }

  return (
    <>
      <Element className="edu-section-gap mea-key-features">
        <div className="container inner about-feature-list">
          <div className="row g-5">
            <div className="col-12 mt-0 px-0 px-md-4">
              <ProductsSectionTitle
                classes = "text-center"
                title = "AURA Agentic AI"
              />
            </div>
            <div className="col-12 mt-5 px-0 px-md-4">
              {showAgentSelection && <form className="agent-selection-form mt-5">
                <Select
                  className="basic-single w-100"
                  placeholder="Select Agent..."
                  onChange={handleSelectedAgent}
                  name="industry"
                  options={agents}
                  value={selectedAgent}
                />
                <button className="edu-btn btn-primary" type="submit" onClick={handleFormSubmit}>Start Chat</button>
              </form>}
              {showChat && <div className="aaai-chat-container">
                {/* <div className="aaai-chat-wrapper"> */}
                  <div className="aaai-chatbox" id="AAAIChatBox"></div>
                  <div className="aaai-chatinput-wrapper d-flex flex-row">
                    <input type="text" value={chatInput} placeholder="start your conversation here..." onChange={(e) => setChatInput(e.target.value)} />
                    <button className="aaai-chat-submit" onClick={handleChatSubmit}>Send</button>
                  </div>
                {/* </div> */}
              </div>}
            </div>
          </div>
        </div>
      </Element>
    </>
  )
}

export default AURAAgents;